/**
 * One switch for the hardened checkout in the Vue app.
 *
 * Off unless a deployment sets VUE_APP_CHECKOUT_V2=true, so the legacy flow stays the
 * default until the cutover is rehearsed and approved.
 */
export const CHECKOUT_V2_ENABLED = process.env.VUE_APP_CHECKOUT_V2 === 'true'
